import { get } from '@helpcenter/ajax';
import { Observable } from '@helpcenter/epics-rxjs';
import { getMeta } from '@helpcenter/meta';
import { APOLLO_STARGATE_CONTEXT_ROOT } from 'rest/constants';
import type { AjaxError } from 'rxjs/observable/dom/AjaxObservable';
import { trackError } from '@atlassian/help-center-common-util/analytics';

export interface LinkedSpacesResponse {
    linkedSpaces: {
        spaceKey: string;
    }[];
}

interface FetchLinkedSpacesAjaxResponse {
    response: LinkedSpacesResponse;
}

export const fetchLinkedSpaces = (): Observable<LinkedSpacesResponse> => {
    const activationId = getMeta('activation-id') as string;
    const uri = `${APOLLO_STARGATE_CONTEXT_ROOT}/${activationId}/api/jsm-portal/linked-spaces`;

    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return get(uri, { 'Content-Type': 'application/json' })
        .map(({ response }: FetchLinkedSpacesAjaxResponse) => {
            return response;
        })
        .catch((e: AjaxError) => {
            trackError('linked-spaces.fetch.failed', {}, e);
            return Observable.throw(e);
        });
};
